"use strict";
function commay(val){
    return val
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        ;
}

(function(){
    let gCaptcha = false;
    $('form').submit(function(e){
        let form = $(this);
        $(form).find('[type=submit]').prop('disabled', true);
        if($(form).find('input.number').length){
            $(form).find('input.number').each(function(){
                let numVal = $(this).val();
                if(numVal) {
                    $(this).val(numVal.replace(/,/g, ''));
                }
            });
        }
        if($(form).data('form-action')!=undefined && grecaptcha!=undefined && !gCaptcha) {
            let formAction = $(form).attr('data-form-action'), siteKey = '6Len6M4iAAAAAMeZH-77F6u510sQZvLlA8MnWvsw';
            e.preventDefault();
            grecaptcha.ready(function () {
                grecaptcha.execute(siteKey, {action: formAction}).then(function (token) {
                    if (token) {
                        gCaptcha = true;
                        $(form).find('[name=form-action]').val(formAction).end().find('input[name=captToken]').val(token).end().find('[type=submit]').prop('disabled', false).end().submit();
                    }
                });
            });
        }
        return true;
    });
}());

const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2
});

let responseModal = $("#responseModal");
responseModal.on('hidden.bs.modal', function(){
    responseModal.find(".modal-body").html("");
}).on('show.bs.modal', function(){
    $('.modal').modal('hide');
});

window.onload = function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
}

$(document).ready(function(){
    "use strict";

    initMenu();

    function initMenu()
    {
        let hamb = $('.navbar-toggler'), close = $('.menu_close_container');

        hamb.on('click', function()
        {
            let elemID = $(this).data('target');
            openMenu(elemID);
        });

        close.on('click', function()
        {
            $(this).parents('.menu').removeClass('active');
        });
    }

    function openMenu(elem)
    {
        $(elem).addClass('active');
    }

    $('input.number').each(function(){
        let numVal = $(this).val();
        if(numVal) {
            $(this).val(commay(numVal));
        }
    });
}).on('keyup', 'input.number', function(){
    if(event.which >= 37 && event.which <= 40) return;
    $(this).val(commay($(this).val()));
}).on('change', 'input[type=file]', function(ev){
    var max = 5500000,
        mySize = this.files[0].size;

    if(max > mySize){
        ev.target.setCustomValidity('');
        $(this).removeClass('is-invalid').parent().find('.invalid-feedback').html('');
    }else{
        ev.target.setCustomValidity('Maximum file size 5MB.');
        $(this).addClass('is-invalid').parent().find('.invalid-feedback').html('Maximum file size 5MB.');
    }
});
